var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myButton"},[_c('div',{style:(_vm.beforeColor)},[_vm._v(_vm._s(_vm.info))]),_c('div',{style:(_vm.afterColor)},[_vm._v(_vm._s(_vm.info))]),_c('div',{style:(_vm.afterColor)},[_vm._v(_vm._s(_vm.info))])])}
var staticRenderFns = []

export { render, staticRenderFns }